import { render, staticRenderFns } from "./MultipleUploadImage.vue?vue&type=template&id=3ff838b0&scoped=true&"
import script from "./MultipleUploadImage.vue?vue&type=script&lang=ts&"
export * from "./MultipleUploadImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff838b0",
  null
  
)

export default component.exports